import useWriteReviewStore from '~/modules/reviews/stores/useWriteReviewStore';
import { passStoreThroughComposableFactory } from '~/utils/passStoreThroughComposableFactory';

const useWriteReview = () => passStoreThroughComposableFactory(useWriteReviewStore());

export default useWriteReview;
